import { gql } from '@apollo/client'

export const GET_PRICE_LISTS = gql`
  query pricingPlans($first: Int, $last: Int) {
    pricingPlans(first: $first, last: $last) {
      totalCount
      nodes {
        id
        name
        default
        pricings {
          id
          target
          startDate
          endDate
          mediaFormatOfferPricings {
            id
            mediaFormat
            offer
            valueCents
          }
        }
      }
    }
  }
`
